import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { JSONValue } from '@growthbook/growthbook';
import { filter, firstValueFrom } from 'rxjs';
import { GrowthBookFeature, GrowthBookService } from './service';
import { ExperimentProps } from './types';

export function growthbookMatcher(flag: GrowthBookFeature, value: JSONValue = true, defaultValue?: JSONValue): CanMatchFn {
  return async function growthbookMatchFn() {
    const service = inject(GrowthBookService);
    await firstValueFrom(service.initialized.pipe(filter(x => x)));

    return service.getFeatureValue(flag, defaultValue) === value;
  };
}

export function splitTestMatcher(experimentName: string): CanMatchFn {
  return async function splitTestMatchFn() {
    const service = inject(GrowthBookService);
    await firstValueFrom(service.initialized.pipe(filter(x => x)));

    const experimentResult = service.getFeatureValue<ExperimentProps>(experimentName);

    // Return true if variationid is 'B', false otherwise
    return experimentResult?.variationid === 'B';
  };
}
